/**
 * Wallet mapper - converts API response types to domain entities
 */
import type { WalletResponse } from "../../shared/api/wallet";
import type { Wallet } from "./model";

/**
 * Map API WalletResponse to domain Wallet entity
 */
export function mapWalletResponseToEntity(response: WalletResponse): Wallet {
  return {
    id: response.id,
    network: response.network,
    workchain: response.workchain,
    rawAddress: response.rawAddress,
    friendlyAddress: response.friendlyAddress,
    walletVersion: response.walletVersion,
    publicKeyHex: response.publicKeyHex,
    balance: response.balance,
    isDeployed: response.isDeployed,
    lastSyncSeqno: response.lastSyncSeqno,
    lastSyncedAt: response.lastSyncedAt ? new Date(response.lastSyncedAt) : null,
    isVerified: response.isVerified,
    verifiedAt: response.verifiedAt ? new Date(response.verifiedAt) : null,
    metadata: response.metadata,
    createdAt: new Date(response.createdAt),
    updatedAt: new Date(response.updatedAt),
  };
}

